import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { ChangeHistoryMacroRendererProps } from '../src/ChangeHistoryMacroRenderer.tsx';

export const ChangeHistoryMacroHandler: LoadableType<ChangeHistoryMacroRendererProps> =
	LoadablePaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-ChangeHistoryMacro" */ '../src/ChangeHistoryMacroRenderer.tsx'
				)
			).ChangeHistoryMacroRenderer,
	});
